export const PATH = '/screencontext';
